import axios from "axios";
import { appendTimestamp } from "../../common/shared";
import { SERVER_URL } from "../../config";

export const getAdvisorSecurityQuestion = (advisorId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${SERVER_URL}/advisor/${advisorId}/securityquestion`)
      .then((response) => {
        resolve(response);
      });
  });
};

export const getAdvisorSecurityQuestionList = (advisorId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${SERVER_URL}/advisor/${advisorId}/securityquestions`)
      .then((response) => {
        resolve(response);
      });
  });
};

export const getUserProfile = (advisorId) => {
  const getAdvisorInfoPromise = axios.get(
    appendTimestamp(`${SERVER_URL}/advisor/${advisorId}/info`)
  );
  const getAdvisorAddressPromise = axios.get(
    `${SERVER_URL}/advisor/${advisorId}/address`
  );
  const getAdvisorSecurityQuestionPromise = axios.get(
    `${SERVER_URL}/advisor/${advisorId}/securityquestion`
  );

  const getSecurityQuestionListPromise = axios.get(
    `${SERVER_URL}/advisor/${advisorId}/securityquestions`
  );

  const getAdvisorSignaturePromise = axios.get(
    `${SERVER_URL}/advisor/${advisorId}/signature`
  );

  return new Promise((resolve, reject) => {
    Promise.all([
      getAdvisorInfoPromise,
      getAdvisorAddressPromise,
      getAdvisorSecurityQuestionPromise,
      getSecurityQuestionListPromise,
      getAdvisorSignaturePromise,
    ]).then((userProfileItems) => {
      const advisorInfo = userProfileItems[0].data.payload;
      const advisorAddress = userProfileItems[1].data.payload;
      const securityQuestion = userProfileItems[2].data.payload;
      const securityQuestionList = userProfileItems[3].data.payload;
      const signature = userProfileItems[4].data.payload;

      resolve({
        userId: advisorInfo.email,
        contactInfo: {
          firstName: advisorInfo.firstName,
          lastName: advisorInfo.lastName,
          phoneNumber: advisorInfo.phoneNumber,
        },
        address: {
          addressId: advisorAddress.addressId,
          addressLine: advisorAddress.addressLine,
          city: advisorAddress.city,
          state: advisorAddress.state,
          zipCode: advisorAddress.zipCode,
          country: advisorAddress.country,
        },
        securityQuestionList: securityQuestionList.map((question) => {
          return {
            id: question.id,
            question: question.question,
          };
        }),
        security: {
          question: {
            id: securityQuestion.questionNum,
            question:
              securityQuestion.questionNum !== null
                ? securityQuestionList.find((item) => {
                    return item.id === securityQuestion.questionNum;
                  }).question
                : "",
          },
          answer: securityQuestion.answer,
          password: "",
        },
        signature: signature.userSignature ? signature.userSignature : "",
      });
    });
  });
};

export const saveAdvisorInfo = (advisorId, advisorInfo) => {
  console.log("saveAdvisorInfo");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/info`
    );

    axios.put(targetUrl, advisorInfo).then(() => {
      resolve({});
    });
  });
};

export const saveAdvisorAddressInfo = (advisorId, addressInfo) => {
  console.log("saveAdvisorAddressInfo");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/address`
    );

    axios.put(targetUrl, addressInfo).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const saveSecurityQuestion = (advisorId, questionInfo) => {
  console.log("saveSecurityQuestion");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/securityquestion`
    );

    axios.post(targetUrl, questionInfo).then(() => {
      resolve({});
    });
  });
};

export const updateAdvisorPassword = (advisorId, passwordInfo) => {
  console.log("updateAdvisorPassword");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/updatepassword`
    );

    axios.put(targetUrl, passwordInfo).then((response) => {
      resolve(response);
    });
  });
};

export const loadAdvisorSignature = (advisorId) => {
  console.log("loadAdvisorSignature");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/signature`
    );

    axios.get(targetUrl).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const saveAdvisorSignature = (advisorId, signature) => {
  console.log("saveAdvisorSignature");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/advisorsignature/save`
    );

    axios.post(targetUrl, signature).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const loadAdvisorAvatar = (advisorId) => {
  console.log("loadAdvisorAvatar");

  return new Promise((resolve, reject) => {
    axios
      .get(`${SERVER_URL}/advisor/${advisorId}/advisorimage`)
      .then((response) => {
        resolve(response.data.payload);
      });
  });
};

export const saveAdvisorAvatar = (advisorId, data) => {
  console.log("saveAdvisorAvatar");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/uploadImage`
    );

    const formData = new FormData();
    formData.append("image", data);
    axios
      .post(targetUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        resolve(response.data.payload);
      });
  });
};

export const saveAdvisorAppearance = (advisorId, appearance) => {
  console.log("saveAdvisorSignature");

  return new Promise((resolve, reject) => {
    const targetUrl = appendTimestamp(
      `${SERVER_URL}/advisor/${advisorId}/advisorappearance/save`
    );

    axios.post(targetUrl, appearance).then((response) => {
      resolve(response.data.payload);
    });
  });
};

export const getAdvisorSignature = (advisorId) => {
  console.log("getAdvisorSignature");

  return new Promise((resolve, reject) => {
    axios
      .get(`${SERVER_URL}/advisor/${advisorId}/signature`)
      .then((response) => {
        const signature = response.data.payload.userSignature
          ? response.data.payload.userSignature
          : "";
        resolve(signature);
      });
  });
};
